module.exports = {"460201400":"国营南田农场","460201401":"国营南新农场","460201403":"国营立才农场","460201404":"国营南滨农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/460201.json
// module id = 2316
// module chunks = 0